<ng-container *ngIf="viewModel$ | async as viewModel">
  <div class="p-col-12" style="padding-bottom: 1rem; margin-bottom: 1rem">
    <div class="header-with-buttons">
      <header class="p-my-2 estimates-header">
        <h2>Events</h2>
      </header>
      <div>
        <button
          pButton
          class="p-button-text p-m-1 workorders-btn-text"
          [icon]="
            viewModel.isAllEventsCollapsed
              ? 'pi pi-chevron-down'
              : 'pi pi-chevron-up'
          "
          [label]="
            viewModel.isAllEventsCollapsed ? 'Expand All' : 'Collapse All'
          "
          (click)="store.dispatch(actions.toggleAllEventsButtonClicked())"
        ></button>
        <app-add-event-button
          *hasPermission="['calendarEvents.create']"
        ></app-add-event-button>
      </div>
    </div>
    <div
      class="empty-state"
      *ngIf="!viewModel.jobLoading && viewModel.workorders.length === 0"
    >
      <i class="pi pi-calendar"></i>
      <span>No events for this job.</span>
    </div>
    <div
      class="p-datatable p-component data-table"
      *ngFor="
        let event of viewModel.workorders;
        let i = index;
        trackBy: trackByEventId
      "
    >
      <div
        class="p-datatable-wrapper main-wrapper p-md-12 card"
        #workorderRef
        [attr.data-id]="event.eventId"
      >
        <div class="event-header">
          <div class="event-info-container">
            <div class="main-info">
              <div>
                <span
                  class="p-text-bold p-mb-1 freya-link-button"
                  (click)="
                    store.dispatch(
                      actions.eventDetailsClicked({ eventId: event.eventId })
                    )
                  "
                >
                  {{ event.title }}
                </span>
              </div>
              <div>
                <span class="event-date">{{ event.eventDate }}</span>
              </div>
            </div>
            <div class="tags-container">
              <p-tag
                *ngIf="event"
                severity="success"
                class="p-ml-2 totals-tag"
                [pTooltip]="discountsTooltipContent"
                value="{{
                  event.discountedSubTotal / 100
                    | currency: viewModel.job?.currency || 'USD'
                }}"
              >
              </p-tag>
              <p-tag
                *ngIf="event"
                class="p-ml-2"
                severity="info"
                value="{{ event.type | titlecase }} {{
                  event.displayStatus | titlecase
                }}"
              ></p-tag>
              <p-tag
                *ngIf="event | eventHasInvoice"
                value="Invoiced"
                severity="success"
              ></p-tag>
              <ng-container *ngIf="!event.hasUnsavedChanges; else saveButton">
                <button
                  *ngIf="
                    event?.status === 'required' || event?.status === 'pending'
                  "
                  pButton
                  class="p-m-2 p-button-outlined workorders-btn-outlined"
                  label="Book"
                  (click)="
                    store.dispatch(
                      actions.bookEventButtonClicked({ eventId: event.eventId })
                    )
                  "
                  icon="pi pi-calendar-plus"
                  [disabled]="event.bookButtonDisabled"
                  [pTooltip]="event.bookButtonDisabledTooltip"
                ></button>
              </ng-container>
              <button
                *hasPermission="['calendarEvents.edit']"
                pButton
                type="button"
                icon="pi pi-ellipsis-v"
                class="p-button-icon-only p-button-text ellipsis-button"
                (click)="
                  store.dispatch(
                    actions.openEventActionsButtonClicked({
                      eventId: event.eventId,
                    })
                  );
                  eventActionsMenu.toggle($event)
                "
                [disabled]="viewModel.jobLoadingOrUpdating"
              ></button>
              <button
                type="button"
                pButton
                pRipple
                class="p-button-text p-button-rounded p-button-plain event-row-button"
                [pTooltip]="
                  viewModel.collapsed[event.eventId]
                    ? 'Expand Event'
                    : 'Collapse Event'
                "
                [icon]="
                  viewModel.collapsed[event.eventId]
                    ? 'pi pi-chevron-down'
                    : 'pi pi-chevron-up'
                "
                (click)="
                  store.dispatch(
                    actions.toggleEventButtonClicked({ eventId: event.eventId })
                  )
                "
              ></button>
            </div>
          </div>
        </div>
        <table role="grid" width="100%" class="event-main-container">
          <tbody
            *ngIf="!viewModel.collapsed[event.eventId]"
            class="p-datatable-tbody"
            cdkDropList
            [cdkDropListConnectedTo]="viewModel.validEventIds"
            [cdkDropListData]="event"
            (cdkDropListDropped)="
              store.dispatch(
                actions.chargeDropped({
                  chargeId: $event.item.data.chargeId,
                  newIndex: $event.currentIndex,
                  sourceEventId: $event.previousContainer.data.eventId,
                  targetEventId: $event.container.data.eventId,
                })
              )
            "
            [id]="event.eventId"
            [cdkDropListDisabled]="
              viewModel.jobLoading || event?.locked || event?.invoiced
            "
          >
            <!-- Event Notes (Ray): per-event rich notes for the movers —
                 available on ALL events (not just revenue-generating ones).
                 Collapsible, above Charges; saved to event metadata as a
                 Quill delta. Crew comms render these too. Stays interactive
                 when the row is locked/invoiced (.event-notes-row opts out
                 of the disabled styling). -->
            <tr *ngIf="!viewModel.jobLoading" class="event-notes-row">
              <td colspan="12">
                <div class="event-notes-section" [attr.data-event-id]="event.eventId">
                  <div class="event-notes-header">
                    <button
                      type="button"
                      class="event-notes-toggle"
                      (click)="toggleNotes(event.eventId)"
                      [attr.aria-expanded]="isNotesExpanded(event.eventId)"
                    >
                      <i class="pi" [ngClass]="isNotesExpanded(event.eventId) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                      <span class="p-text-bold event-notes-label">Event Notes</span>
                      <span class="event-notes-hint">visible to crew — not the customer</span>
                    </button>
                    <div class="event-notes-body" *ngIf="isNotesExpanded(event.eventId)">
                      <quill-editor
                        format="object"
                        [modules]="eventNotesModules"
                        [editorId]="'event-notes-' + event.eventId"
                        [ngModel]="getNotesDelta(event.eventId, event.eventNotes)"
                        (ngModelChange)="onNotesChanged(event.eventId, $event)"
                        [placeholder]="'What was done on this event? These notes are sent to the crew.'"
                      ></quill-editor>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="eventTypeInfoMap[event.type]?.revenueGenerating">
              <td colspan="12">
                <p-messages *ngIf="event.disabledWarning" severity="warn">
                  <ng-template pTemplate>
                    <span class="warning-with-action">
                      <span>{{ event.disabledWarning }}</span>
                      <span class="warning-buttons">
                        <button
                          *ngIf="viewModel.job?.zone?.type !== 'area'"
                          pButton
                          label="Set Area"
                          icon="pi pi-map-marker"
                          class="p-button-warning p-button-outlined"
                          (click)="
                            store.dispatch(actions.setAreaButtonClicked())
                          "
                          style="pointer-events: auto"
                        ></button>
                        <button
                          *ngIf="event?.locked"
                          pButton
                          [label]="
                            (freyaHelper.lockDateSupportInfo$ | async)
                              ?.contactAccountingButtonText ||
                            'Contact Accounting'
                          "
                          icon="pi pi-send"
                          class="p-button-warning p-button-outlined"
                          (click)="freyaHelper.contactAccounting(event.eventId)"
                          style="pointer-events: auto"
                        ></button>
                      </span>
                    </span>
                  </ng-template>
                </p-messages>
                <div class="charges-with-actions">
                  <div>
                    <h6 class="p-text-bold p-mb-1">Charges</h6>
                  </div>
                  <div class="charges-container add-buttons">
                    <p-button
                      icon="pi pi-sparkles"
                      class="btn-m-r-1"
                      *ngIf="viewModel.aiGenerateChargesEnabled"
                      [loading]="viewModel.generateChargesWithAILoading"
                      label="Generate"
                      (onClick)="
                        store.dispatch(
                          actions.generateChargesButtonClicked({
                            eventId: event.eventId,
                          })
                        )
                      "
                    ></p-button>
                    <button
                      *hasPermission="['jobs.update']"
                      pButton
                      type="button"
                      class="add-charges-button btn-m-r-1"
                      label="Add Charges"
                      icon="pi pi-plus"
                      (click)="
                        store.dispatch(
                          actions.openAddChargesDialogButtonClicked({
                            eventId: event.eventId,
                          })
                        )
                      "
                      [disabled]="viewModel.jobLoading || event.disabledStatus"
                      [pTooltip]="event.disabledToolTip"
                      tooltipPosition="left"
                    ></button>
                    <button
                      *hasPermission="['jobs.update']"
                      pButton
                      type="button"
                      label="Add Discounts"
                      icon="pi pi-plus"
                      class="add-discounts-button btn-m-r-1"
                      (click)="
                        store.dispatch(
                          actions.addDiscountsButtonClicked({
                            eventId: event.eventId,
                            discountId: viewModel.defaultDiscount.id,
                            amount: viewModel.defaultDiscount.amount,
                          })
                        )
                      "
                      [disabled]="viewModel.jobLoading || event.disabledStatus"
                      [pTooltip]="event.disabledToolTip"
                      tooltipPosition="left"
                    ></button>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="event-row" [class.hidden]="!event?.charges.length">
              <td class="fixed-width hidden-column"></td>
              <td class="hidden-column">Charge</td>
              <td class="hidden-column">Rate</td>
              <td class="hidden-column">Quantity</td>
              <td class="hidden-column subtotal-column">Subtotal</td>
              <td></td>
            </tr>
            <tr *ngIf="viewModel.jobLoading">
              <td></td>
              <td>
                <p-skeleton
                  styleClass="p-mb-1"
                  width="10rem"
                  height="1.5rem"
                ></p-skeleton>
                <p-skeleton width="4rem" height="1.5rem"></p-skeleton>
              </td>
              <td>
                <p-skeleton width="4rem" height="1.5rem"></p-skeleton>
              </td>
              <td>
                <p-skeleton width="4rem" height="1.5rem"></p-skeleton>
              </td>
              <td>
                <p-skeleton width="4rem" height="1.5rem"></p-skeleton>
              </td>
              <td>
                <p-skeleton width="4rem" height="1.5rem"></p-skeleton>
              </td>
            </tr>
            <tr
              *ngFor="let charge of event.charges; trackBy: trackByChargeId"
              cdkDrag
              [cdkDragStartDelay]="
                responsiveHelper.isSmallScreen
                  ? responsiveHelper.dragDelay
                  : undefined
              "
              [cdkDragData]="charge"
              [cdkDragPreviewContainer]="previewContainer"
              class="selectable-row"
            >
              <td
                class="fixed-width color-border"
                cdkDragHandle
                [style.border-right-color]="charge.borderColor"
              >
                <button
                  pButton
                  class="p-button-text p-button-rounded p-button-plain p-button-lg"
                  icon="pi pi-bars"
                ></button>
              </td>
              <td
                (click)="openCharge(viewModel.job, charge)"
                class="charge-name"
              >
                <div class="charge-name-wrapper">
                  <p class="p-text-bold p-mb-1">
                    {{ charge.productName }}
                  </p>
                </div>
                <label>{{ charge.category }} </label>
                <br />
                <small>{{ charge.description }} </small>
                <br />
                <p class="subtotal-label">
                  Subtotal: &nbsp;
                  {{
                    charge.chargeSubTotal / 100
                      | currency: viewModel.job?.currency || 'USD'
                  }}
                </p>
              </td>
              <td class="mobile-separator"></td>
              <td class="mobile-separator"></td>
              <td
                *ngIf="charge.priceType !== 'percentage'"
                class="stack-vertically input-with-subtotal"
              >
                <button
                  pButton
                  type="button"
                  icon="pi pi-ellipsis-v"
                  class="p-button-icon-only p-button-text ellipsis-button mobile-visible"
                  (click)="
                    store.dispatch(
                      actions.openChargeActionsButtonClicked({
                        chargeId: charge.chargeId,
                      })
                    );
                    chargeActionsMenu.toggle($event)
                  "
                  [disabled]="
                    viewModel.jobLoading || event?.locked || event?.invoiced
                  "
                ></button>
                <p-inputNumber
                  [ngModel]="charge.amount"
                  (onInput)="
                    store.dispatch(
                      actions.rateInputChanged({
                        eventId: event.eventId,
                        chargeId: charge.chargeId,
                        amount: $event.value,
                      })
                    )
                  "
                  (onKeyDown)="
                    store.dispatch(
                      actions.rateInputKeyDown({
                        eventId: event.eventId,
                        chargeId: charge.chargeId,
                        event: $event,
                      })
                    )
                  "
                  class="mid-width-number-input mid-width-number-input--adjustable"
                  mode="currency"
                  [currency]="viewModel.job?.currency || 'USD'"
                  [locale]="
                    viewModel.job?.currency === 'CAD' ? 'en-CA' : 'en-US'
                  "
                  [ngClass]="{
                    'p-invalid-input':
                      charge.chargeSubTotal / 100 > subtotalLimit,
                  }"
                ></p-inputNumber>
              </td>
              <td
                *ngIf="charge.priceType === 'percentage'"
                class="stack-vertically"
              >
                <button
                  pButton
                  type="button"
                  icon="pi pi-ellipsis-v"
                  class="p-button-icon-only p-button-text ellipsis-button mobile-visible"
                  (click)="
                    store.dispatch(
                      actions.openChargeActionsButtonClicked({
                        chargeId: charge.chargeId,
                      })
                    );
                    chargeActionsMenu.toggle($event)
                  "
                  [disabled]="
                    viewModel.jobLoading || event?.locked || event?.invoiced
                  "
                ></button>
                <p-inputNumber
                  [ngModel]="charge.amount"
                  (onInput)="
                    store.dispatch(
                      actions.rateInputChanged({
                        eventId: event.eventId,
                        chargeId: charge.chargeId,
                        amount: $event.value,
                      })
                    )
                  "
                  class="mid-width-number-input mid-width-number-input--adjustable"
                  type="number"
                  suffix="%"
                  max="100"
                  min="0"
                ></p-inputNumber>
              </td>
              <td
                *ngIf="charge.priceType !== 'percentage'"
                class="stack-vertically"
              >
                <button
                  pButton
                  type="button"
                  (click)="
                    store.dispatch(
                      actions.removeChargeButtonClicked({
                        chargeId: charge.chargeId,
                      })
                    )
                  "
                  class="delete-charge delete-charge-decrement-replacement mobile-visible p-button-text workorders-btn-text"
                  [class.delete-button-hidden]="charge.quantity > 1"
                  icon="pi pi-trash"
                  [disabled]="
                    viewModel.jobLoading || event?.locked || event?.invoiced
                  "
                ></button>
                <p-inputNumber
                  #quantityInput
                  class="short-number-input mid-width-number-input--adjustable"
                  type="number"
                  [minFractionDigits]="1"
                  [maxFractionDigits]="2"
                  mode="decimal"
                  [showButtons]="true"
                  buttonLayout="horizontal"
                  min="0"
                  incrementButtonIcon="pi pi-plus"
                  decrementButtonIcon="pi pi-minus"
                  [decrementButtonClass]="
                    charge.quantity === 0 ||
                    charge.quantity === 1 ||
                    !charge.quantity
                      ? 'p-button-text workorders-btn-text decrement-button-hidden'
                      : 'p-button-text workorders-btn-text'
                  "
                  incrementButtonClass="p-button-text workorders-btn-text"
                  [ngModel]="charge.quantity"
                  (onInput)="
                    store.dispatch(
                      actions.quantityInputChanged({
                        eventId: event.eventId,
                        chargeId: charge.chargeId,
                        quantity: $event.value,
                      })
                    )
                  "
                  (onBlur)="
                    quantityInput?.value === null &&
                      store.dispatch(
                        actions.quantityInputChanged({
                          eventId: event.eventId,
                          chargeId: charge.chargeId,
                          quantity: 0,
                        })
                      )
                  "
                  [disabled]="
                    viewModel.jobLoading || event?.locked || event?.invoiced
                  "
                  [ngClass]="{
                    'p-invalid-input':
                      charge.chargeSubTotal / 100 > subtotalLimit ||
                      !charge.quantity,
                  }"
                ></p-inputNumber>
              </td>
              <td
                *ngIf="charge.priceType === 'percentage'"
                class="stack-vertically percentage-quantity"
              >
                <button
                  pButton
                  type="button"
                  (click)="
                    store.dispatch(
                      actions.removeChargeButtonClicked({
                        chargeId: charge.chargeId,
                      })
                    )
                  "
                  class="delete-charge percentage-delete-button p-button-text workorders-btn-text"
                  icon="pi pi-trash"
                  [disabled]="
                    viewModel.jobLoading || event?.locked || event?.invoiced
                  "
                ></button>
                <p>N/A</p>
              </td>
              <td
                class="subtotal-column"
                (click)="openCharge(viewModel.job, charge)"
              >
                <span
                  [class.error-text]="
                    charge.chargeSubTotal / 100 > subtotalLimit
                  "
                >
                  {{
                    charge.chargeSubTotal / 100
                      | currency: viewModel.job?.currency || 'USD'
                  }}
                </span>
              </td>
              <td *hasPermission="['jobs.update']" class="hidden-column">
                <div class="charge-actions">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-ellipsis-v"
                    class="p-button-icon-only p-button-text ellipsis-button"
                    (click)="
                      store.dispatch(
                        actions.openChargeActionsButtonClicked({
                          chargeId: charge.chargeId,
                        })
                      );
                      chargeActionsMenu.toggle($event)
                    "
                    [disabled]="
                      viewModel.jobLoading || event?.locked || event?.invoiced
                    "
                  ></button>
                </div>
              </td>
            </tr>
            <tr class="item-row" *ngIf="event?.discounts?.length">
              <td class="fixed-width discount-hidden-column"></td>
              <td class="discount-header-row" colspan="2">Name / Code</td>
              <td class="discount-header-row">Discount</td>
              <td class="discount-header-row">Value</td>
              <td></td>
            </tr>
            <tr
              *ngFor="
                let discount of event.discounts;
                trackBy: trackByAppliedDiscountId
              "
              class="item-row"
            >
              <td class="fixed-width discount-hidden-column"></td>
              <td
                (click)="openDiscount(discount.associatedDiscount)"
                colspan="2"
              >
                <div class="discount-name-wrapper">
                  <span class="discount-name">{{ discount.name }}</span>
                  <br />
                  <span class="discount-code discount-hidden-column">{{
                    discount.code
                  }}</span>
                </div>
              </td>
              <td *ngIf="discount.discountType === 'amount'">
                {{ discount.amount | freyaCurrency: viewModel.job?.currency }}
              </td>
              <td *ngIf="discount.discountType === 'percentage'">
                {{ discount.amount }}%
              </td>
              <td>
                {{
                  discount.discountedAmount
                    | freyaCurrency: viewModel.job?.currency
                }}
              </td>
              <td style="text-align: right">
                <span class="p-column-title"></span>
                <span>
                  <button
                    pButton
                    type="button"
                    icon="pi pi-ellipsis-v"
                    class="p-button-icon-only p-button-text ellipsis-button discount-actions"
                    (click)="
                      store.dispatch(
                        actions.openDiscountActionsButtonClicked({
                          appliedId: discount.appliedId,
                        })
                      );
                      discountActionsMenu.toggle($event)
                    "
                    [disabled]="
                      viewModel.jobLoading || event?.locked || event?.invoiced
                    "
                  ></button>
                </span>
              </td>
            </tr>
            <tr
              [class.hidden]="
                event.charges.length ||
                event.discounts.length ||
                !eventTypeInfoMap[event.type]?.revenueGenerating
              "
            >
              <td colspan="12">
                <div class="flex">
                  <div class="charges-container">
                    <p
                      *ngIf="
                        !viewModel.jobLoading && event?.charges.length === 0
                      "
                    >
                      No charges or discounts added
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="12" class="no-padding"></td>
            </tr>
          </tbody>
        </table>
        <div
          *ngIf="!viewModel.collapsed[event.eventId]"
          class="financials-assets-container"
        >
          <div>
            <h6>Financials</h6>
            <app-job-financials-table [eventId]="event.eventId">
            </app-job-financials-table>
          </div>
          <div>
            <div>
              <h6>Assets</h6>
              <div>
                <div *ngFor="let asset of event.assets">
                  <p>
                    {{ asset.name }}
                    <p-tag [value]="asset.type" severity="info"></p-tag>
                  </p>
                </div>
                <div *ngIf="!event.assets?.length">No Assets Assigned.</div>
              </div>
            </div>
            <div style="margin-top: 1rem">
              <div style="display: flex; align-items: center; justify-content: space-between">
                <h6>Crew</h6>
                <!-- Requirement: #6142 - Crew assignment from workorders is in testing phase — restricted to ymm-interstate-usa zone only -->
                <ng-container *ngIf="viewModel.crewAssignmentEnabled">
                  <p-button
                    *hasPermission="[DISPATCH_PERMISSIONS.viewDispatch]"
                    icon="pi pi-pencil"
                    [text]="true"
                    size="small"
                    [loading]="editingEventId === event.eventId"
                    (onClick)="openEditCrew(event)"
                  ></p-button>
                </ng-container>
              </div>
              <div>
                <div *ngFor="let attendee of event.crew">
                  <p>
                    {{ attendee.user?.familyName }}, {{ attendee.user?.givenName }}
                    <p-tag [value]="attendee.role" severity="success"></p-tag>
                  </p>
                </div>
                <div *ngIf="!event.crew?.length">No Crew Assigned.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashed-container" *ngIf="viewModel.workorders.length > 0">
      <app-add-event-button *hasPermission="['calendarEvents.create']">
      </app-add-event-button>
    </div>
  </div>

  <!-- Cancelled Events Section -->
  <div
    class="p-col-12"
    style="padding-bottom: 1rem; margin-bottom: 1rem"
    *ngIf="viewModel.cancelledEvents.length > 0"
  >
    <div class="header-with-buttons">
      <header class="p-my-2 estimates-header">
        <h2>Cancelled Events</h2>
      </header>
    </div>
    <div
      class="p-datatable p-component data-table"
      *ngFor="
        let event of viewModel.cancelledEvents;
        let i = index;
        trackBy: trackByEventId
      "
    >
      <div
        class="p-datatable-wrapper main-wrapper p-md-12 card"
        [attr.data-id]="event.eventId"
      >
        <div class="event-header">
          <div class="event-info-container">
            <div class="main-info">
              <div>
                <span
                  class="p-text-bold p-mb-1 freya-link-button"
                  (click)="
                    store.dispatch(
                      actions.eventDetailsClicked({ eventId: event.eventId })
                    )
                  "
                >
                  {{ event.title }}
                </span>
              </div>
              <div>
                <span class="event-date">{{ event.eventDate }}</span>
              </div>
            </div>
            <div class="tags-container">
              <p-tag
                *ngIf="event"
                severity="success"
                class="p-ml-2 totals-tag"
                value="{{
                  event.discountedSubTotal / 100
                    | currency: viewModel.job?.currency || 'USD'
                }}"
              >
              </p-tag>
              <p-tag
                *ngIf="event"
                class="p-ml-2"
                severity="warning"
                value="{{ event.type | titlecase }} {{
                  event.status | titlecase
                }}"
              ></p-tag>
            </div>
          </div>
        </div>
        <table role="grid" width="100%" class="event-main-container">
          <tbody class="p-datatable-tbody">
            <tr *ngIf="eventTypeInfoMap[event.type]?.revenueGenerating">
              <td colspan="12">
                <div class="charges-with-actions">
                  <div>
                    <h6 class="p-text-bold p-mb-1">Charges</h6>
                  </div>
                </div>
              </td>
            </tr>
            <tr class="event-row" [class.hidden]="!event?.charges.length">
              <td class="fixed-width hidden-column"></td>
              <td class="hidden-column">Charge</td>
              <td class="hidden-column">Rate</td>
              <td class="hidden-column">Quantity</td>
              <td class="hidden-column subtotal-column">Subtotal</td>
              <td></td>
            </tr>
            <tr
              *ngFor="let charge of event.charges; trackBy: trackByChargeId"
              class="selectable-row"
            >
              <td
                class="fixed-width color-border"
                [style.border-right-color]="charge.borderColor"
              ></td>
              <td
                (click)="openCharge(viewModel.job, charge)"
                class="charge-name"
              >
                <div class="charge-name-wrapper">
                  <p class="p-text-bold p-mb-1">
                    {{ charge.productName }}
                  </p>
                </div>
                <label>{{ charge.category }} </label>
                <br />
                <small>{{ charge.description }} </small>
                <br />
                <p class="subtotal-label">
                  Subtotal: &nbsp;
                  {{
                    charge.chargeSubTotal / 100
                      | currency: viewModel.job?.currency || 'USD'
                  }}
                </p>
              </td>
              <td class="mobile-separator"></td>
              <td class="mobile-separator"></td>
              <td
                *ngIf="charge.priceType !== 'percentage'"
                class="stack-vertically input-with-subtotal"
              >
                <p-inputNumber
                  [ngModel]="charge.amount"
                  class="mid-width-number-input mid-width-number-input--adjustable"
                  mode="currency"
                  [currency]="viewModel.job?.currency || 'USD'"
                  [locale]="
                    viewModel.job?.currency === 'CAD' ? 'en-CA' : 'en-US'
                  "
                  [disabled]="true"
                ></p-inputNumber>
              </td>
              <td
                *ngIf="charge.priceType === 'percentage'"
                class="stack-vertically"
              >
                <p-inputNumber
                  [ngModel]="charge.amount"
                  class="mid-width-number-input mid-width-number-input--adjustable"
                  type="number"
                  suffix="%"
                  max="100"
                  min="0"
                  [disabled]="true"
                ></p-inputNumber>
              </td>
              <td
                *ngIf="charge.priceType !== 'percentage'"
                class="stack-vertically"
              >
                <p-inputNumber
                  class="short-number-input mid-width-number-input--adjustable"
                  type="number"
                  [minFractionDigits]="1"
                  [maxFractionDigits]="2"
                  mode="decimal"
                  [showButtons]="true"
                  buttonLayout="horizontal"
                  min="0"
                  incrementButtonIcon="pi pi-plus"
                  decrementButtonIcon="pi pi-minus"
                  decrementButtonClass="p-button-text workorders-btn-text"
                  incrementButtonClass="p-button-text workorders-btn-text"
                  [ngModel]="charge.quantity"
                  [disabled]="true"
                ></p-inputNumber>
              </td>
              <td
                *ngIf="charge.priceType === 'percentage'"
                class="stack-vertically percentage-quantity"
              >
                <p>N/A</p>
              </td>
              <td
                class="subtotal-column"
                (click)="openCharge(viewModel.job, charge)"
              >
                <span>
                  {{
                    charge.chargeSubTotal / 100
                      | currency: viewModel.job?.currency || 'USD'
                  }}
                </span>
              </td>
              <td class="hidden-column"></td>
            </tr>
            <tr class="item-row" *ngIf="event?.discounts?.length">
              <td class="fixed-width discount-hidden-column"></td>
              <td class="discount-header-row" colspan="2">Name / Code</td>
              <td class="discount-header-row">Discount</td>
              <td class="discount-header-row">Value</td>
              <td></td>
            </tr>
            <tr
              *ngFor="
                let discount of event.discounts;
                trackBy: trackByAppliedDiscountId
              "
              class="item-row"
            >
              <td class="fixed-width discount-hidden-column"></td>
              <td
                (click)="openDiscount(discount.associatedDiscount)"
                colspan="2"
              >
                <div class="discount-name-wrapper">
                  <span class="discount-name">{{ discount.name }}</span>
                  <br />
                  <span class="discount-code discount-hidden-column">{{
                    discount.code
                  }}</span>
                </div>
              </td>
              <td *ngIf="discount.discountType === 'amount'">
                {{ discount.amount | freyaCurrency: viewModel.job?.currency }}
              </td>
              <td *ngIf="discount.discountType === 'percentage'">
                {{ discount.amount }}%
              </td>
              <td>
                {{
                  discount.discountedAmount
                    | freyaCurrency: viewModel.job?.currency
                }}
              </td>
              <td style="text-align: right"></td>
            </tr>
            <tr
              [class.hidden]="
                event.charges.length ||
                event.discounts.length ||
                !eventTypeInfoMap[event.type]?.revenueGenerating
              "
            >
              <td colspan="12">
                <div class="flex">
                  <div class="charges-container">
                    <p *ngIf="event?.charges.length === 0">
                      No charges or discounts added
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="12" class="no-padding"></td>
            </tr>
          </tbody>
        </table>
        <div class="financials-assets-container">
          <div>
            <h6>Financials</h6>
            <app-job-financials-table
              [eventId]="event.eventId"
              readonly="true"
            >
            </app-job-financials-table>
          </div>
          <div>
            <div>
              <h6>Assets</h6>
              <div>
                <div *ngFor="let asset of event.assets">
                  <p>
                    {{ asset.name }}
                    <p-tag [value]="asset.type" severity="info"></p-tag>
                  </p>
                </div>
                <div *ngIf="!event.assets?.length">No Assets Assigned.</div>
              </div>
            </div>
            <div style="margin-top: 1rem">
              <h6>Crew</h6>
              <div>
                <div *ngFor="let attendee of event.crew">
                  <p>
                    {{ attendee.user?.familyName }}, {{ attendee.user?.givenName }}
                    <p-tag [value]="attendee.role" severity="success"></p-tag>
                  </p>
                </div>
                <div *ngIf="!event.crew?.length">No Crew Assigned.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-add-charges></app-add-charges>
  <app-discounts-modal></app-discounts-modal>

  <!-- Requirement: #6142 - Crew assignment from workorders is in testing phase — restricted to ymm-interstate-usa zone only -->
  <ng-container *ngIf="viewModel.crewAssignmentEnabled">
    <p-dialog
      [modal]="true"
      [(visible)]="crewEditDialogVisible"
      [closable]="false"
      [draggable]="true"
      [breakpoints]="{ '1024px': '62vw', '510px': '93vw' }"
      [style]="{ width: '35vw' }"
    >
      <ng-template pTemplate="headless">
        <app-dispatch-edit-event
          *ngIf="eventForCrewEdit"
          [event]="eventForCrewEdit"
          [showTrucks]="false"
          [showAvailableCrew]="true"
          (closeDialog)="closeCrewEditDialog()"
        ></app-dispatch-edit-event>
      </ng-template>
    </p-dialog>
  </ng-container>

  <p-menu
    #discountActionsMenu
    appendTo="body"
    [popup]="true"
    [model]="viewModel.discountActions"
  ></p-menu>

  <p-menu
    #chargeActionsMenu
    appendTo="body"
    [popup]="true"
    [model]="viewModel.chargeActions"
  ></p-menu>

  <p-menu
    #eventActionsMenu
    appendTo="body"
    [popup]="true"
    [model]="viewModel.eventActions"
  ></p-menu>

  <ng-template #discountsTooltipContent>
    <table class="tooltip-table">
      <tr>
        <td>Discounts</td>
        <td>
          {{
            viewModel.job?.discountTotal / 100
              | currency: viewModel.job?.currency || 'USD'
          }}
        </td>
      </tr>
      <tr>
        <td>Damages</td>
        <td>
          {{
            viewModel.job?.damageTotal / 100
              | currency: viewModel.job?.currency || 'USD'
          }}
        </td>
      </tr>
      <tr>
        <td>Taxes</td>
        <td>
          {{
            viewModel.job?.taxTotal / 100
              | currency: viewModel.job?.currency || 'USD'
          }}
        </td>
      </tr>
    </table>
  </ng-template>

  <ng-template #saveButton>
    <button
      pButton
      class="p-m-2 p-button-outlined workorders-btn-outlined"
      label="Save"
      (click)="store.dispatch(actions.saveButtonClicked())"
      [icon]="
        viewModel.jobBeingUpdated ? 'pi pi-spin pi-spinner' : 'pi pi-save'
      "
      [disabled]="
        viewModel.jobLoadingOrUpdating || viewModel.hasInvalidNewEvents
      "
      [pTooltip]="
        viewModel.hasInvalidNewEvents
          ? 'Cannot save: Events have invalid locations'
          : ''
      "
    ></button>
  </ng-template>
</ng-container>
